export default "__VITE_ASSET__d4422fcb__"